/* eslint-disable import/prefer-default-export */

export const parseSignerData = data => {
  let isSigned = false;
  data.user.user_email = data.user.user_email.toLowerCase();
  const activeSigner = data.user.user_email;
  const obj = {};
  data.signatories_v2 = data.signatories_v2.map(signer => {
    signer.signer_email = signer.signer_email.toLowerCase();

    // if field_values are present then update them to signatories
    if (signer.field_values) {
      const { tags } = signer;
      signer.tags = tags.map(t => {
        const { tag_id } = t.signer_config;
        if (signer.field_values[tag_id]) {
          t.signer_config.tag_value = signer.field_values[tag_id];
        }
        return t;
      });
    }
    return signer;
  });

  data.signatories_v2.forEach(item => {
    if (item.signer_email === activeSigner) {
      isSigned = item.is_signed;
    }
    Object.assign(obj, { [item.signer_identity_id]: item });
  });

  return {
    doc_name: data.doc_name,
    doc_owner: data.doc_created_by,
    doc_stage: data.doc_stage,
    is_lz: data.is_lz,
    is_integration_org: data.is_integration_org,
    is_ep_document: data.is_ep_document,
    redirect_url: data.redirect_url,
    doc_object_id: data.doc_object_id,
    isSigned,
    signatories: obj,
    user: data.user,
    link_expiry_time: data.link_expiry_time,
  };
};
